module.exports = __webpack_public_path__ + "static/media/21a.3236c405.jpg";